@use "../../styles/breakpoint.module.scss" as *;

.actions {
    display: flex;
    justify-content: center;
}

.hideAboveTablet {
    @media ($above-tablet) {
        display: none;
    }
}
